import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEntitiesOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M2.75 5.646a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-5.167 9.52c0-.967.784-1.75 1.75-1.75h4c.967 0 1.75.783 1.75 1.75v4a1.75 1.75 0 0 1-1.75 1.75h-4a1.75 1.75 0 0 1-1.75-1.75zm1.75-.25a.25.25 0 0 0-.25.25v4c0 .138.112.25.25.25h4a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25zm9.681-6.098a1.25 1.25 0 0 1 2.165 0l3.03 5.25a1.25 1.25 0 0 1-1.082 1.875h-6.062a1.25 1.25 0 0 1-1.082-1.875l3.03-5.25Zm1.082 1.125-2.598 4.5h5.196z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEntitiesOutlined;
